/* ==========================================================
   Emma Market Editorial JS
   ========================================================== */

(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ----------------------------------------------------------
     Mobile Drawer
     ---------------------------------------------------------- */
  function initDrawer() {
    var toggleBtns = document.querySelectorAll('[data-drawer-toggle]');
    var drawer = document.querySelector('.ant-drawer');
    var overlay = document.querySelector('.ant-drawer-overlay');
    var closeBtns = document.querySelectorAll('[data-drawer-close]');

    if (!drawer) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      drawer.setAttribute('aria-hidden', 'false');
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      drawer.setAttribute('aria-hidden', 'true');
    }

    toggleBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (drawer.classList.contains('is-open')) {
          closeDrawer();
        } else {
          openDrawer();
        }
      });
    });

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', closeDrawer);
    });

    if (overlay) {
      overlay.addEventListener('click', closeDrawer);
    }

    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });
  }

  /* ----------------------------------------------------------
     Bottom Sheet (filters / sort)
     ---------------------------------------------------------- */
  function initBottomSheet() {
    var sheets = document.querySelectorAll('.ant-sheet');
    var sheetOverlay = document.querySelector('.ant-sheet-overlay');

    if (!sheets.length) return;

    function closeAll() {
      sheets.forEach(function (sheet) {
        sheet.classList.remove('is-open');
      });
      if (sheetOverlay) sheetOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    function openSheet(sheet) {
      closeAll();
      sheet.classList.add('is-open');
      if (sheetOverlay) sheetOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    sheets.forEach(function (sheet) {
      var id = sheet.id;
      if (!id) return;

      var triggers = document.querySelectorAll('[data-sheet="' + id + '"]');
      triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation(); // prevent document listener from closing immediately
          if (sheet.classList.contains('is-open')) {
            closeAll();
          } else {
            openSheet(sheet);
          }
        });
      });

      // Close via handle / X button
      var closeBtns = sheet.querySelectorAll('[data-sheet-close]');
      closeBtns.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          closeAll();
        });
      });

      // Swipe down to close
      var startY = 0;
      sheet.addEventListener('touchstart', function (e) {
        startY = e.touches[0].clientY;
      }, { passive: true });

      sheet.addEventListener('touchend', function (e) {
        if (e.changedTouches[0].clientY - startY > 60) closeAll();
      }, { passive: true });

      // Prevent clicks inside the sheet from reaching the document listener
      sheet.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    });

    // Close when clicking outside (on overlay or anywhere else on the page)
    document.addEventListener('click', function (e) {
      var anyOpen = document.querySelector('.ant-sheet.is-open');
      if (anyOpen) closeAll();
    });

    // Overlay also closes on click (belt + suspenders)
    if (sheetOverlay) {
      sheetOverlay.addEventListener('click', closeAll);
    }
  }

  /* ----------------------------------------------------------
     PDP Sticky CTA
     ---------------------------------------------------------- */
  function initStickyCTA() {
    var stickyCTA = document.querySelector('.ant-sticky-cta');
    if (!stickyCTA) return;

    var scrollThreshold = 600;

    function onScroll() {
      if (window.scrollY > scrollThreshold) {
        stickyCTA.classList.add('is-visible');
      } else {
        stickyCTA.classList.remove('is-visible');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    // Sticky add button → click main product-form submit button
    var stickyAddBtn = stickyCTA.querySelector('[data-sticky-add]');
    if (stickyAddBtn) {
      stickyAddBtn.addEventListener('click', function () {
        var mainBtn = document.querySelector('.product-form__submit, [name="add"]');
        if (mainBtn) {
          mainBtn.click();
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      });
    }

    // Sync variant selection label and price to sticky CTA
    var mainVariantPicker = document.querySelector('variant-selects, variant-radios');
    var stickyVariantInfo = stickyCTA.querySelector('.ant-sticky-cta__variant');
    var stickyBtn = stickyCTA.querySelector('.ant-sticky-cta__btn');
    var stickyAvailableLabel = stickyBtn ? stickyBtn.textContent.split('—')[0].trim() : '';
    var productInfo = document.querySelector('product-info');

    function updateStickyVariant() {
      var checked = document.querySelectorAll('.product-form__input input:checked');
      if (checked.length && stickyVariantInfo) {
        var parts = Array.from(checked).map(function (el) {
          var label = el.nextElementSibling;
          var colorName = label && label.querySelector('.emma-color-option__name');
          return colorName ? colorName.textContent.trim() : el.value;
        });
        stickyVariantInfo.textContent = parts.join(' · ');
      }

      // Update price from Dawn's variant picker selected price element
      var priceEl = document.querySelector('.price__sale .price-item--sale, .price__regular .price-item--regular');
      var mainSubmit = productInfo && productInfo.querySelector('[name="add"]');
      if (stickyBtn && mainSubmit) {
        stickyBtn.disabled = mainSubmit.disabled;
        var priceText = priceEl ? priceEl.textContent.trim() : '';
        stickyBtn.textContent = mainSubmit.disabled
          ? mainSubmit.textContent.trim()
          : stickyAvailableLabel + (priceText ? ' — ' + priceText : '');
      }
    }

    if (productInfo) {
      productInfo.addEventListener('change', updateStickyVariant);
      new MutationObserver(updateStickyVariant).observe(productInfo, {
        subtree: true, childList: true, attributes: true, attributeFilter: ['disabled']
      });
    }

    // Also listen to Dawn's variant:change custom event
    document.addEventListener('variant:change', updateStickyVariant);
    updateStickyVariant();
  }

  /* ----------------------------------------------------------
     Carousels — swipe threshold to prevent hair-trigger snapping
     ---------------------------------------------------------- */
  function initCarousels() {
    var THRESHOLD = 50; // px — minimum swipe to advance a slide

    document.querySelectorAll('.ant-carousel').forEach(function (carousel) {
      var startX = 0;
      var startScrollLeft = 0;
      var didSwipe = false;

      carousel.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        startScrollLeft = carousel.scrollLeft;
        didSwipe = false;
      }, { passive: true });

      carousel.addEventListener('touchend', function (e) {
        var deltaX = Math.abs(e.changedTouches[0].clientX - startX);
        if (deltaX >= THRESHOLD) {
          didSwipe = true;
        } else {
          // Too small — snap back to original position
          carousel.scrollTo({ left: startScrollLeft, behavior: 'smooth' });
        }
      }, { passive: true });

      // Prevent accidental link navigation when the user has swiped
      carousel.addEventListener('click', function (e) {
        if (didSwipe) {
          e.preventDefault();
          didSwipe = false;
        }
      }, true);
    });
  }

  /* ----------------------------------------------------------
     Home hero slideshow
     ---------------------------------------------------------- */
  function initHeroSlideshows() {
    document.querySelectorAll('[data-hero-slideshow]').forEach(function (slideshow) {
      var slides = Array.from(slideshow.querySelectorAll('[data-hero-slide]'));
      var hero = slideshow.closest('.ant-hero');
      var controls = hero && hero.querySelector('.ant-hero__controls');
      if (slides.length < 2 || !controls) return;

      var dots = Array.from(controls.querySelectorAll('[data-hero-dot]'));
      var pauseButton = controls.querySelector('[data-hero-pause]');
      var title = hero.querySelector('[data-hero-title]');
      var description = hero.querySelector('[data-hero-text]');
      var interval = parseInt(slideshow.dataset.heroInterval, 10) || 6000;
      var current = 0;
      var timer = null;
      var hoverPaused = false;
      var focusPaused = false;
      var userPaused = reducedMotion;
      var userStarted = false;

      function updateCopy(index) {
        var slide = slides[index];
        if (!slide) return;
        if (title) title.textContent = slide.dataset.title;
        if (description) description.textContent = slide.dataset.text;
      }

      updateCopy(current);

      function setObjectPosition(index) {
        var image = slides[index];
        if (!image) return;
        image.style.objectPosition = window.matchMedia('(max-width: 767px)').matches
          ? (image.dataset.mobileObjectPosition || 'center center')
          : (image.dataset.desktopObjectPosition || '72% center');
      }

      setObjectPosition(current);
      window.addEventListener('resize', function () { setObjectPosition(current); });

      function loadSlide(index, callback) {
        var image = slides[index];
        if (image.getAttribute('src')) {
          if (image.complete && image.naturalWidth) callback();
          else {
            image.addEventListener('load', callback, { once: true });
            image.addEventListener('error', callback, { once: true });
          }
          return;
        }

        image.addEventListener('load', callback, { once: true });
        image.addEventListener('error', callback, { once: true });
        var mobileSource = image.parentElement && image.parentElement.querySelector('source[data-mobile-srcset]');
        if (mobileSource && window.matchMedia(mobileSource.media).matches) {
          mobileSource.srcset = mobileSource.dataset.mobileSrcset;
        }
        image.setAttribute('src', image.dataset.src);
        image.removeAttribute('data-src');
      }

      function preloadNext() {
        var next = slides[(current + 1) % slides.length];
        if (next && next.dataset.src) {
          var preloader = new Image();
          var mobileSource = next.parentElement && next.parentElement.querySelector('source[data-mobile-srcset]');
          preloader.src = mobileSource && window.matchMedia(mobileSource.media).matches
            ? mobileSource.dataset.mobileSrcset
            : next.dataset.src;
        }
      }

      function canPlay() {
        return !userPaused && (!reducedMotion || userStarted) && !hoverPaused && !focusPaused && !document.hidden;
      }

      function stop() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }

      function start() {
        stop();
        if (!canPlay()) return;
        timer = window.setInterval(function () {
          show((current + 1) % slides.length);
        }, interval);
      }

      function show(index) {
        loadSlide(index, function () {
          [title, description].forEach(function (copy) {
            if (copy) copy.classList.add('is-changing');
          });
          window.setTimeout(function () {
            updateCopy(index);
            [title, description].forEach(function (copy) {
              if (copy) copy.classList.remove('is-changing');
            });
          }, 180);
          slides[current].classList.remove('is-active');
          slides[current].setAttribute('aria-hidden', 'true');
          slides[index].classList.add('is-active');
          slides[index].setAttribute('aria-hidden', 'false');
          setObjectPosition(index);
          dots.forEach(function (dot, dotIndex) {
            dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
          });
          current = index;
          preloadNext();
          start();
        });
      }

      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          stop();
          show(index);
        });
      });

      if (pauseButton) {
        function updatePauseButton() {
          pauseButton.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
          pauseButton.setAttribute('aria-label', userPaused ? pauseButton.dataset.labelPlay : pauseButton.dataset.labelPause);
          var icon = pauseButton.querySelector('[data-pause-icon]');
          if (icon) {
            icon.setAttribute('d', userPaused ? 'M5 3.5v9l7-4.5z' : 'M4 3h2.5v10H4zM9.5 3H12v10H9.5z');
          }
        }

        pauseButton.addEventListener('click', function () {
          userPaused = !userPaused;
          if (!userPaused) userStarted = true;
          updatePauseButton();
          start();
        });
        updatePauseButton();
      }

      hero.addEventListener('mouseenter', function () {
        hoverPaused = true;
        stop();
      });
      hero.addEventListener('mouseleave', function () {
        hoverPaused = false;
        start();
      });
      controls.addEventListener('focusin', function () {
        focusPaused = true;
        stop();
      });
      controls.addEventListener('focusout', function () {
        window.setTimeout(function () {
          focusPaused = controls.contains(document.activeElement);
          start();
        }, 0);
      });
      document.addEventListener('visibilitychange', start);

      preloadNext();
      start();
    });
  }

  /* ----------------------------------------------------------
     Reduced Motion
     ---------------------------------------------------------- */
  function applyReducedMotion() {
    if (!reducedMotion) return;
    document.documentElement.classList.add('reduced-motion');
    var marquees = document.querySelectorAll('.ant-marquee-track');
    marquees.forEach(function (el) {
      el.style.animation = 'none';
    });
  }

  /* ----------------------------------------------------------
     Wishlist — Lista de deseos (localStorage)
     ---------------------------------------------------------- */
  var WISH_KEY = 'ant_wishlist';

  function wishGet() {
    try { return JSON.parse(localStorage.getItem(WISH_KEY)) || []; } catch(e) { return []; }
  }

  function wishSave(list) {
    localStorage.setItem(WISH_KEY, JSON.stringify(list));
    wishUpdateHeader();
  }

  function wishHas(handle) {
    return wishGet().some(function(p) { return p.handle === handle; });
  }

  function wishAdd(product) {
    var list = wishGet();
    if (!list.some(function(p) { return p.handle === product.handle; })) {
      list.push(product);
      wishSave(list);
    }
  }

  function wishRemove(handle) {
    wishSave(wishGet().filter(function(p) { return p.handle !== handle; }));
  }

  function wishToggle(handle, product) {
    if (wishHas(handle)) { wishRemove(handle); } else { wishAdd(product); }
    wishSyncAll(handle);
  }

  function wishSyncAll(handle) {
    var saved = wishHas(handle);
    document.querySelectorAll('[data-wishlist-handle="' + handle + '"]').forEach(function(btn) {
      btn.classList.toggle('is-saved', saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    });
    wishUpdateHeader();
  }

  function wishProductFromBtn(btn) {
    return {
      handle: btn.dataset.wishlistHandle,
      title:  btn.dataset.wishlistTitle,
      image:  btn.dataset.wishlistImage,
      price:  btn.dataset.wishlistPrice,
      url:    btn.dataset.wishlistUrl
    };
  }

  function initWishlist() {
    // Card heart buttons
    document.querySelectorAll('.ant-wish-btn').forEach(function(btn) {
      var handle = btn.dataset.wishlistHandle;
      if (!handle) return;
      btn.setAttribute('aria-pressed', wishHas(handle) ? 'true' : 'false');
      if (wishHas(handle)) btn.classList.add('is-saved');
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        wishToggle(handle, wishProductFromBtn(btn));
      });
    });

    // PDP button
    var pdpBtn = document.querySelector('.ant-wish-pdp-btn');
    if (pdpBtn) {
      var handle = pdpBtn.dataset.wishlistHandle;
      pdpBtn.setAttribute('aria-pressed', wishHas(handle) ? 'true' : 'false');
      if (wishHas(handle)) pdpBtn.classList.add('is-saved');
      pdpBtn.addEventListener('click', function() {
        wishToggle(handle, wishProductFromBtn(pdpBtn));
      });
    }

    wishUpdateHeader();

    // Wishlist page
    var grid = document.getElementById('ant-wishlist-grid');
    if (grid) wishRenderPage(grid);
  }

  function wishUpdateHeader() {
    var count = wishGet().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function(node) {
      node.textContent = count;
      node.toggleAttribute('hidden', count === 0);
    });
  }

  function wishRenderPage(grid) {
    var list = wishGet();
    var empty = document.getElementById('ant-wishlist-empty');

    if (list.length === 0) {
      grid.innerHTML = '';
      grid.style.display = 'none';
      if (empty) { empty.style.display = 'flex'; }
      return;
    }

    if (empty) empty.style.display = 'none';
    grid.style.display = 'grid';

    grid.innerHTML = list.map(function(p) {
      return '<div class="ant-wcard">' +
        '<a href="' + p.url + '" class="ant-wcard-img">' +
          '<img src="' + p.image + '" alt="' + p.title + '" loading="lazy">' +
        '</a>' +
        '<div class="ant-wcard-body">' +
          '<a href="' + p.url + '" class="ant-wcard-title">' + p.title + '</a>' +
          '<p class="ant-wcard-price">' + p.price + '</p>' +
          '<button type="button" class="ant-wcard-remove" data-handle="' + p.handle + '">' +
            '× ' + (grid.dataset.removeLabel || 'Remove') +
          '</button>' +
        '</div>' +
      '</div>';
    }).join('');

    grid.querySelectorAll('.ant-wcard-remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        wishRemove(btn.dataset.handle);
        wishSyncAll(btn.dataset.handle);
        wishRenderPage(grid);
      });
    });
  }

  /* ----------------------------------------------------------
     Init
     ---------------------------------------------------------- */
  document.addEventListener('DOMContentLoaded', function () {
    initDrawer();
    initBottomSheet();
    initStickyCTA();
    initCarousels();
    initHeroSlideshows();
    applyReducedMotion();
    initWishlist();
  });

})();

